/**
 * Builds the list of filter chip values for a column.
 * Configured filter values stay in the UI (grayed out when unused);
 * values from data are merged in so unexpected categories still appear.
 */
export const buildTableFilterValues = (
  dataValues: unknown[],
  filters: string[] = []
): string[] => {
  const fromData = dataValues
    .map((value) => {
      if (value == null) {
        return "";
      }
      return String(value).trim();
    })
    .filter((value) => value.length > 0);

  const filtersTrimmed = filters
    .map((value) => value.trim())
    .filter((value) => value.length > 0);

  return Array.from(new Set([...filtersTrimmed, ...fromData]));
};
